import { connect } from 'react-redux';
import LowerProductSpecific from './lowerProductSpecific';

const mapStateToProps = ({ detailsPage }) => ({
  content:
    (detailsPage.loadedProduct.contentSlotsHtml &&
      detailsPage.loadedProduct.contentSlotsHtml.LowerProductSpecificContent) ||
    '',
});

export default connect(mapStateToProps)(LowerProductSpecific);
